import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  matriculaId: Yup.string().required(mensagemPadrao),
  motivoId: Yup.string().required(mensagemPadrao),
  motivoDetalhado: Yup.string().required(mensagemPadrao)
})
